import { EditParam } from '../../../../../components/Modals/Instances/Modules/EditParam'
import useStyles from './useStyles'

function TableItem ({ item }) {
  const classes = useStyles()

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemName}>{item.app_parameter_desc}</td>
        <td className={classes.itemValue}>
          {Number.parseInt(item.parameter_num_value)}
        </td>
        <td className={classes.itemKebab}>
          <EditParam param={item} />
        </td>
      </tr>
    </>
  )
}

export default TableItem
